var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selector"},[_vm._m(0),_c('div',{staticStyle:{"height":"36vh","margin-top":"4vh"},attrs:{"id":_vm.id}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("选择图层")])])
}]

export { render, staticRenderFns }